import { Accordion } from 'common/accordion/accordion.js';
import { IconWithText } from 'common/icon/icon-with-text.js';
import { LegendKeys } from 'components/legends/legend-keys.js';
import { memo } from 'react';
import { IMapGeneralKeyContent, IMapKey } from 'types/location.js';

interface IProps {
  keys?: IMapKey[];
}

const LegendsKeysCore = ({ keys }: IProps) => {
  if (!keys) {
    return null;
  }

  if (keys.length === 1) {
    return <LegendKeys {...keys[0]} showLabel />;
  }

  /** We know that custom headers dont have multiple tabs */
  const headers = (keys as IMapGeneralKeyContent[]).map(({ icon, label }, index) => {
    return (
      <IconWithText
        iconClass="svg-fill-font-color u-textSlate"
        key={index}
        icon={icon}
        classes="IconWithText--small IconWithText--vCenter"
      >
        <small>{label}</small>
      </IconWithText>
    );
  });

  const bodies = keys.map((key, index) => (
    <div key={index} className="Accordion-item-body">
      <LegendKeys {...key} showLabel={false} />
    </div>
  ));

  return (
    <Accordion
      restrictToOnlyOneChildOpen
      className="Accordion--inTile"
      headers={headers}
      bodies={bodies}
      dataComponent="legend-keys"
    />
  );
};

const LegendsKeys = memo(LegendsKeysCore);
export { LegendsKeys };
